<template>
  <MainLayout :title="trans('Order payment')">
    <div
      class="sticky top-0 z-10 bg-theme-background"
      style="padding-top: var(--safe-area-inset-top)"
    >
      <div class="flex items-center p-4">
        <h1
          class="flex-1 truncate px-4 text-center font-primary text-lg font-medium"
        >
          {{ trans('Order payment') }}
        </h1>
      </div>
    </div>

    <div class="p-4">
      <StripePaymentElement
        v-if="initiatedPayment"
        :stripe-account="initiatedPayment.stripeAccount"
        :client-secret="initiatedPayment.clientSecret"
        :publishable-key="initiatedPayment.publishableKey"
        :return-url="initiatedPayment.returnUrl"
      />
      <div v-else class="py-10 text-center text-xl">
        {{ trans('Please wait') }}...
      </div>
    </div>
  </MainLayout>
</template>

<script setup lang="ts">
import axios from 'axios';
import MainLayout from '@menu/Shared/MainLayout.vue';
import StripePaymentElement from '@menu/Shared/StripePaymentElement.vue';
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useToast } from 'vue-toastification';
import { trans } from '@menu/Utils/i18n';

const route = useRoute();
const router = useRouter();
const toast = useToast();

const initiatedPayment = ref<{
  stripeAccount: string;
  clientSecret: string;
  publishableKey: string;
  returnUrl: string;
}>();

const initiatePayment = () => {
  axios
    .post(`/api/orders/${route.params.orderUuid}/initiate-payment`)
    .then((response) => {
      if (response.data.data.skipPayment) {
        router.push({
          name: 'order',
          params: { orderUuid: route.params.orderUuid },
        });
      } else {
        initiatedPayment.value = response.data.data;
      }
    })
    .catch(() => {
      toast.error('Something went wrong.');
    });
};

onMounted(initiatePayment);
</script>
